import {canUserMarkUnreadOrRead, ProviderEvent, ProviderEventColumn, ProviderEventType, ProviderEventTypeNameMap} from "./domain";
import React, {Dispatch} from "react";
import {get} from "lodash";
import {ProviderEventColumns} from "./ProviderEventList";
import {formatDate} from "../../common/util/date";
import {ProviderEventListAction} from "./providerEventListReducer";
import {fullName} from "core/domain";
import {parseISO} from "date-fns";
import {ProviderEventPreviewDescription} from "./ProviderEventPreviewDescription";
import {CurrentUserData} from "../../security";

type ProviderEventPreviewProps = {
    selected: boolean;
    currentUser: CurrentUserData | null;
    markEventAsReadFunc: (eventGuids: string[]) => void;
    dispatch: Dispatch<ProviderEventListAction>;
    providerEvent: ProviderEvent;
    onConfirmEndDateClick?: (providerEvent: ProviderEvent) => void;
}

export function ProviderEventPreview({
                                         currentUser,
                                         providerEvent,
                                         selected,
                                         dispatch,
                                         markEventAsReadFunc,
                                         onConfirmEndDateClick,
                                     }: ProviderEventPreviewProps) {
    const viewed = !!providerEvent.viewedAt;
    const displayColumn = (column: ProviderEventColumn) => {
        const value = get(providerEvent as Record<string, any>, column.attr)
        if (column.attr === "_description") {
            return ProviderEventPreviewDescription(providerEvent, () => {
                if (providerEvent.viewedAt || !canUserMarkUnreadOrRead(currentUser, providerEvent)) {
                    return;
                }

                markEventAsReadFunc([providerEvent.guid]);
            }, selected);
        }
        if (column.attr === "eventType") {
            return ProviderEventTypeNameMap.get(value);
        }

        if (column.attr === "_actions") {
            const eventType = ProviderEventTypeNameMap.get(providerEvent.eventType);
            if (eventType === ProviderEventType.Treatment_Hold_End && !providerEvent.holdActionCompletedAt) {
                return (
                    <button
                        type="button"
                        className="px-3 py-1 text-sm focus:outline-none"
                        style={{
                            backgroundColor: '#FFF',
                            color: '#00AB93',
                            borderColor: '#00AB93',
                            border: '1px solid',
                        }}
                        onClick={(e) => {
                            e.stopPropagation();
                            onConfirmEndDateClick?.(providerEvent);
                        }}
                    >
                        Confirm End Date
                    </button>
                );
            }
            return null;
        }

        if (column.attr === "viewedBy" && value) {
            return fullName(providerEvent.viewedBy);
        }
        if (column.attr === "clientReport.submittedBy" && value) {
            return fullName(providerEvent?.clientReport?.submittedBy);
        }

        if (["eventTime", "viewedAt"].includes(column.attr) && value) {
            return formatDate(parseISO(value));
        }

        return (<>
            {value}
        </>);
    }


    return (
        <tr className={`border-b border-gray-200 relative hover:${selected ? 'bg-botticelli-100' : "bg-gray-200"} 
        ${selected ? 'bg-botticelli-100 text-white' : ''}
        ${viewed ? "" : "bg-blue-100 border-gray-300"}`}>
            {
                ProviderEventColumns.map((column) => (
                    <td
                        key={column.name}
                        className={'py-5' + (column.attr === '_description' ? ' pl-8' : '')}
                        onClick={() => {
                            if (column.attr === '_actions') {
                                return;
                            }
                            dispatch({type: "SET_SELECTED", selected: providerEvent});
                        }}
                    >
                        {
                            displayColumn(column)
                        }
                    </td>
                ))
            }
        </tr>
    );
}
